import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { useNaturalSizeImage } from '../../../modules/image/imageUtil'

export default function ImageSize({ imageRef }) {
  if (_.isEmpty(imageRef)) {
    return null
  }
  const { width, height } = useNaturalSizeImage(imageRef)

  return (
    <ImageSizeLayout>
      <div className="tag">
        {width} x {height}
      </div>
    </ImageSizeLayout>
  )
}

ImageSize.propTypes = {
  imageRef: PropTypes.object,
}

const ImageSizeLayout = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  display: flex;
`
ImageSizeLayout.display = 'ImageSizeLayout'



// WEBPACK FOOTER //
// ./src/components/templates/image-preview/ImageSize.js